<h2>Project Milestones</h2>
<digires-milestone-legend></digires-milestone-legend>

<mat-accordion class="schedule-tab-accordion" [multi]="true">

  <mat-expansion-panel>
    <mat-expansion-panel-header>
      <mat-panel-title class="schedule-tab-accordion-title">
        <h3>Business Transaction - Approval Type (DoA) Selectors</h3>
      </mat-panel-title>
    </mat-expansion-panel-header>

    <digires-governance-group-selector *ngFor="let group of governanceGroups"
                                        [milestoneDefs]="milestoneDefs"
                                        [formGroup]="governanceSelectorFormGroup"
                                        [group]="group"
                                        [readOnly]="readOnly"
                                        [readOnlyReason]="readOnlyReason"
    ></digires-governance-group-selector>

  </mat-expansion-panel>

  <mat-expansion-panel *ngFor="let stage of scheduleData.stages" expanded="true">
    <mat-expansion-panel-header>
      <mat-panel-title class="schedule-tab-accordion-title">
        <h3>{{stageToLabel[stage]}}</h3>
        <svg *ngIf="stage === governanceSelectorFormGroup.value.stage" class="schedule-tab-active-stage-chevron" viewBox="0 0 40 20" preserveAspectRatio="none">
          <path d="
                M  0 10
                L 10  0
                H 40
                L 30 10
                L 40 20
                H 10
                Z
                " stroke-width="1"/>
        </svg>
        <div class="schedule-tab-accordion-title-counter">
          Completed {{scheduleData[stage].doneCount}} / {{scheduleData[stage].milestones.length}}
        </div>
      </mat-panel-title>
    </mat-expansion-panel-header>

    <section class="schedule-tab-stage">

      <digires-chevron-vertical class="schedule-tab-stage-chevron"
                                 [label]="stageToChevronLabel[stage]"
                                 [highlight]="stage === currentStageFormGroup.value.stage"
      ></digires-chevron-vertical>

      <div class="schedule-tab-stage-milestones">

        <ng-container *ngFor="let ms of scheduleData[stage].milestones">

          <digires-milestone-entry *ngIf="!ms.construction && !ms.hasIncomingDependencies && milestoneEntries[ms.id]"
                                   [data]="milestoneEntries[ms.id]"
                                   [readOnly]="readOnly || ms.hasIncomingDependencies"
                                   [readOnlyReason]="readOnlyReason"
                                   [projectCreation]="projectCreation"
                                   (onDateClicked)="onDateClicked.emit({event: $event, data: milestoneEntries[ms.id]})"
          ></digires-milestone-entry>

          <digires-milestone-entry *ngIf="ms.hasIncomingDependencies"
                                   [data]="milestoneEntries[ms.id]"
                                   [readOnly]="true"
                                   readOnlyReason="This milestone is an Auto-Updated milestone. Its date and completion
                                   status is determined by the Predecessor milestones that are linked to it."
          ></digires-milestone-entry>

          <digires-construction-milestone-entry *ngIf="ms.construction && milestoneEntries[ms.id]"
                                                [data]="milestoneEntries[ms.id]"
                                                [readOnly]="readOnly"
                                                [readOnlyReason]="readOnlyReason"
                                                [canEditFid]="canEditFid"
                                                [projectCreation]="projectCreation"
                                                (onDateClicked)="onDateClicked.emit({event: $event, data: milestoneEntries[ms.id]})"
          ></digires-construction-milestone-entry>

        </ng-container>

        <digires-milestone-entry *ngIf="isDevelopmentStage(stage) || isConstructionStage(stage)"
                                 [data]="milestoneEntries[scheduleData[stage].endOfStage.id]"
                                 [readOnly]="true"
                                 readOnlyReason="This milestone indicates the end of a development stage.
                                 Its date and completion status is determined by the key milestones of the stage."
        ></digires-milestone-entry>

      </div>

    </section>

  </mat-expansion-panel>

</mat-accordion>

<h2>Additional Project Dates</h2>

<section class="schedule-tab-section">

  <button [disabled]="readOnly" mat-button (click)="onUserMilestoneAdd()">
    <mat-icon>add</mat-icon>
    Add New Date
  </button>

  <digires-user-milestone-entry *ngFor="let ms of userMilestoneEntries"
                                 [data]="ms"
                                 [readOnly]="readOnly"
                                 (onDelete)="onUserMilestoneDelete(ms)">
  </digires-user-milestone-entry>

</section>
